import React from "react";
import styled from "styled-components";
import { Field, reduxForm } from "redux-form";
import { FormattedMessage, injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { BoldPrimaryButton, SecondaryButton } from "../../../common/Button";
import buttonMessages from "../../../../intl/common/buttonMessages";
import courtesyCarsPricingMessages from "../../../../intl/admin/courtesyCarsPricingMessages";
import { InputFieldWithValidation } from "../../../common/InputFieldWithValidation";
import { positiveNumber } from "../../../common/validationCommons";
import { RequiredSpan } from "../../../common/StyledComponents";
import { courtesyCarsLevels } from "../../../../constants/Utils";
const Button = styled(SecondaryButton)`
    margin-right: 10px;
`;

const TableContainer = styled.div`
    margin-bottom: 20px;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
`;

const Th = styled.th`
    text-align: left;
    padding: 8px;
    border-bottom: 2px solid #ddd;
    background-color: #f8f9fa;
`;

const Td = styled.td`
    padding: 8px;
    border-bottom: 1px solid #ddd;
`;

const CourtesyCarsPricingForm = ({
    handleSubmit,
    pristine,
    reset,
    submitting,
    intl: { formatMessage },
}) => {
    const renderLevelInputs = () => {
        const levels = Array.from({ length: courtesyCarsLevels.MAX_LEVELS }, (_, i) => i + 1);

        return (
            <TableContainer>
                <Table>
                    <thead>
                        <tr>
                            <Th>
                                <FormattedMessage
                                    {...courtesyCarsPricingMessages.LEVEL}
                                />
                            </Th>
                            <Th>
                                <FormattedMessage
                                    {...courtesyCarsPricingMessages.DAILY_RATE}
                                />
                            </Th>
                            <Th>
                                <FormattedMessage
                                    {...courtesyCarsPricingMessages.DAILY_RATE_LOCAL}
                                />
                            </Th>
                        </tr>
                    </thead>
                    <tbody>
                        {levels.map((level) => (
                            <tr key={level}>
                                <Td>Level {level} {level === 1 && <RequiredSpan>{"\u00A0* EUR"}</RequiredSpan>}</Td>
                                <Td>
                                    <InputFieldWithValidation
                                        field={`level${level}.dailyRate`}
                                        validations={[positiveNumber]}
                                        maxLength={5}
                                        isRequired={level === 1}
                                    />
                                </Td>
                                <Td>
                                    <InputFieldWithValidation
                                        field={`level${level}.dailyRateLocal`}
                                        validations={[positiveNumber]}
                                        maxLength={5}
                                    />
                                </Td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </TableContainer>
        );
    };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                {renderLevelInputs()}
                <div className="row">
                    <div className="col">
                        <BoldPrimaryButton
                            type="submit"
                            disabled={pristine || submitting}
                            className="btn float-right"
                        >
                            <FormattedMessage {...buttonMessages.SAVE} />
                        </BoldPrimaryButton>
                        <Button
                            type="button"
                            disabled={pristine || submitting}
                            className="btn float-right"
                            onClick={reset}
                        >
                            <FormattedMessage {...buttonMessages.CANCEL} />
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    );
};

CourtesyCarsPricingForm.propTypes = {
    submitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
};

export default reduxForm({
    enableReinitialize: true,
})(injectIntl(CourtesyCarsPricingForm));

